import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "overlay"]
  static values = { id: String }

  play() {
    if (!this.hasIdValue || !/^[\w-]{11}$/.test(this.idValue)) return
    if (this.frameTarget.dataset.loaded === "true") return

    const iframe = document.createElement("iframe")
    iframe.className = "absolute inset-0 h-full w-full"
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.idValue}?autoplay=1&rel=0`
    iframe.title = "Mind League Africa Promo Video"
    iframe.loading = "lazy"
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    iframe.referrerPolicy = "strict-origin-when-cross-origin"
    iframe.allowFullscreen = true

    this.frameTarget.innerHTML = ""
    this.frameTarget.appendChild(iframe)
    this.frameTarget.dataset.loaded = "true"
    this.overlayTarget.classList.add("hidden")
  }
}
